/**
 * @author he jia
 * @date 2025-05-20
 * @description 项目完善信息
 */
import { inject, observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import styles from './style.m.less';
import { Button, Modal, Form } from 'antd';
import DynamicForm from '@/components/DynamicForm';
import ToastUtils from '@/utils/ToastUtils';
import AuthStyle from '@/components/Auth/style.m.less';
import dayjs from 'dayjs';
const ImproveModal = (props) => {
    const { improveInformation } = props.store;
    const [editForm] = Form.useForm();
    const [resData, setResData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitDisabled, setSubmitIsDisabled] = useState(false);

    const checkIsSubmitDisabled = (fieldsValue) => {
        // setSubmitIsDisabled(false);
        let isDisabled = false;
        const data: any = improveInformation.state.dynamicForm;
        for (let i = 0; i < data?.length; i++) {
            const v = data[i];
            const valTxt = fieldsValue[v['en_name']];
            const valIsEmpty = valTxt === undefined || valTxt === '' || valTxt === null;
            if (Array.isArray(valTxt)) {
                if (v.required === 0 && valTxt?.length === 0) {
                    isDisabled = true;
                    break;
                }
            }
            if (v.required === 0 && valIsEmpty) {
                isDisabled = true;
                break;
            }
            if (v.field_type === 3) {
                const [min = 0, max = 100] = v.setting?.number_range || [];
                if (!valIsEmpty && (valTxt < min || valTxt > max)) {
                    isDisabled = true;
                    break;
                }
                if (v.required !== 0 && valIsEmpty) {
                    isDisabled = false;
                }
            }
        }

        setSubmitIsDisabled(isDisabled);
    };
    const getImproveInformationDetailInfo = async () => {
        await improveInformation.getImproveInformationDetail({ business_id: props.business_id, template_id: props.template_id });
        setResData(improveInformation.state.dynamicForm);
        setSubmitIsDisabled(improveInformation.state.projectEndFlag);
        editForm.setFieldsValue({ ...improveInformation.state.initialValues });
        setIsLoading(false);
        if (!improveInformation.state.projectEndFlag) {
            checkIsSubmitDisabled(improveInformation.state.initialValues);
        }
    };

    const FORMAT_MAP = {
        1: 'YYYY',
        2: 'YYYY-MM',
        3: 'YYYY-MM-DD',
        default: 'YYYY-MM-DD HH:mm:ss'
    };
    const handleSave = () => {
        editForm
            .validateFields()
            .then(async (res) => {
                resData.forEach((item: any) => {
                    // 1. 非日期类型字段直接跳过
                    if (item?.field_type !== 5) return;
                    const { en_name, setting = {} } = item;
                    // 2. 空值提前处理
                    if (!res[en_name]) {
                        res[en_name] = '';
                        return;
                    }
                    const { showTime, type } = setting;
                    // 获取格式化模板
                    const formatStr = FORMAT_MAP[showTime] || FORMAT_MAP.default;
                    // 3. 核心优化：增加异常处理，避免无效日期/非数组导致的报错
                    if (type === 'range') {
                        // 校验是否为合法数组，避免解构报错
                        if (Array.isArray(res[en_name]) && res[en_name].length === 2) {
                            const [start, end] = res[en_name];
                            // 校验日期有效性，无效则置空
                            const formatStart = dayjs(start).isValid() ? dayjs(start).format(formatStr) : '';
                            const formatEnd = dayjs(end).isValid() ? dayjs(end).format(formatStr) : '';
                            // 只要有一个无效，整体置空；否则返回格式化数组
                            res[en_name] = formatStart && formatEnd ? [formatStart, formatEnd] : '';
                        } else {
                            // 非合法范围数组，置空（兜底处理）
                            res[en_name] = '';
                        }
                    } else {
                        // 单日期校验有效性，避免格式化出 "Invalid Date"
                        res[en_name] = dayjs(res[en_name]).isValid() ? dayjs(res[en_name]).format(formatStr) : '';
                    }
                });

                const { success, msg } = await improveInformation.saveImproveInformation({
                    business_id: props.business_id,
                    template_id: props.template_id,
                    ...res
                });
                if (success) {
                    ToastUtils.showSuccessToast('保存成功');
                    if (props.type === 'edit') {
                        setTimeout(() => {
                            props.close(false);
                        }, 1000);
                    } else {
                        props.nextStep();
                    }
                } else {
                    ToastUtils.showToast(msg || '保存失败');
                }
            })
            .catch((err) => {
                console.log(err, 'err');
            });
    };
    useEffect(() => {
        if (props.open && props.type === 'edit') {
            improveInformation.setState({
                type: props.type
            });
            setIsLoading(true);
            getImproveInformationDetailInfo();
        }
    }, [props.open]);

    useEffect(() => {
        improveInformation.setState({
            type: props.type
        });
        setIsLoading(true);
        getImproveInformationDetailInfo();
    }, []);

    const labelCol = props.type === 'add' ? { span: 4 } : { span: 5 };
    const wrapperCol = props.type === 'add' ? { span: 18 } : { span: 19 };

    return props.type === 'add' ? (
        <div className={styles['modal-wrap']}>
            <div
                className={`${AuthStyle['authModalContent']}`}
                style={{ paddingTop: '24px' }}
                // data-scrollbar={resData.length > 7}
            >
                <Form
                    form={editForm}
                    name="basic"
                    preserve={false}
                    labelCol={labelCol}
                    wrapperCol={wrapperCol}
                    autoComplete="off"
                    onValuesChange={(changedValues, allValues) => {
                        checkIsSubmitDisabled(allValues);
                    }}
                >
                    {resData.map((item: any, idx) => {
                        return (
                            <DynamicForm
                                key={idx}
                                {...item}
                                labelCol={labelCol}
                                wrapperCol={wrapperCol}
                                isComplete={true}
                                form={editForm}
                                updated={improveInformation.state.projectEndFlag ? 1 : 0}
                            ></DynamicForm>
                        );
                    })}
                </Form>
            </div>

            <div className={`${AuthStyle['authModalButton']}`}>
                <Button onClick={handleSave} style={{ width: '262px' }} type="primary" loading={isLoading} disabled={isSubmitDisabled}>
                    提交
                </Button>
            </div>
        </div>
    ) : props.type === 'edit' ? (
        <Modal
            title={'项目完善信息'}
            width={730}
            open={props.open}
            closable={props.type === 'edit'}
            footer={null}
            onCancel={() => {
                props.close(false);
            }}
            destroyOnClose={true}
            maskClosable={false}
        >
            <div className={styles['modal-wrap']}>
                <div className={styles['form-wrap']} data-scrollbar={resData.length > 7}>
                    <Form
                        form={editForm}
                        name="basic"
                        preserve={false}
                        labelCol={labelCol}
                        wrapperCol={wrapperCol}
                        autoComplete="off"
                        onValuesChange={(changedValues, allValues) => {
                            checkIsSubmitDisabled(allValues);
                        }}
                    >
                        {resData.map((item: any, idx) => {
                            return (
                                <DynamicForm
                                    key={idx}
                                    {...item}
                                    labelCol={labelCol}
                                    wrapperCol={wrapperCol}
                                    isComplete={true}
                                    form={editForm}
                                    updated={improveInformation.state.projectEndFlag ? 1 : 0}
                                ></DynamicForm>
                            );
                        })}
                    </Form>
                </div>

                <div className={styles['footer-wrap']}>
                    <Button onClick={handleSave} type="primary" loading={isLoading} disabled={isSubmitDisabled}>
                        保存
                    </Button>
                </div>
            </div>
        </Modal>
    ) : null;
};
export default inject('store')(observer(ImproveModal));
